/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Stat_Copies_ValueInputs */

const en_fw_guide_stat_copies_value = /** @type {(inputs: Fw_Guide_Stat_Copies_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4M+`)
};

const zh_fw_guide_stat_copies_value = /** @type {(inputs: Fw_Guide_Stat_Copies_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`400万+`)
};

/**
* | output |
* | --- |
* | "4M+" |
*
* @param {Fw_Guide_Stat_Copies_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_stat_copies_value = /** @type {((inputs?: Fw_Guide_Stat_Copies_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Stat_Copies_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_stat_copies_value(inputs)
	return zh_fw_guide_stat_copies_value(inputs)
});
export { fw_guide_stat_copies_value as "fw.guide.stat.copies_value" }